"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterSelect = FilterSelect;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _PrefixedSelect = require("../prefixed-select/PrefixedSelect");
var _filterSelectModule = _interopRequireDefault(require("./filter-select.module.scss"));
var _excluded = ["value", "className", "filterName", "defaultValue", "onChange", "prefixIcon"];
function FilterSelect(_ref) {
  var value = _ref.value,
    className = _ref.className,
    filterName = _ref.filterName,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    prefixIcon = _ref.prefixIcon,
    selectProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(value !== defaultValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  (0, _react.useEffect)(function () {
    setActive(value !== defaultValue);
  }, [value, defaultValue]);
  return /*#__PURE__*/_react.default.createElement(_PrefixedSelect.PrefixedSelect, Object.assign({
    prefix: filterName,
    prefixIcon: prefixIcon,
    className: (0, _classnames.default)(_filterSelectModule.default['filter-select'], className, (0, _defineProperty2.default)({}, _filterSelectModule.default['filter-select--active'], active)),
    value: value,
    onChange: onChange
  }, selectProps));
}